import { graphql } from "react-relay";

export const UpdateEmailProfileMutation = graphql`
  mutation UpdateEmailProfileMutation($input: UpdateEmailConfigurationInput!) {
    updateEmailProfile(input: $input) {
      configuration {
        profile
        record {
          ... on EmailConfiguration {
            fromEmail
            sesRegion
            smtp {
              port
              server
              ssl
              username
            }
          }
        }
        scope
      }
    }
  }
`;
